import React from "react";

import Select from "react-select";
const SingleSelect = ({ option = [], onChange, value }) => {
  return (
    <div>
      <Select
        // defaultValue={[colourOptions[2], colourOptions[3]]}
        value={value}
        name="colors"
        options={option}
        className="basic-multi-select"
        classNamePrefix="select"
        onChange={onChange}
      />
    </div>
  );
};

export default SingleSelect;
